import { CustomLanding, Flavours } from '../services/types';
import { AmplitudeDepositFlow } from 'common/services/amplitude/types';

export const DEPOSIT_CONSTANTS = {
  RedirectErrors: ['merchant_gateway_merchant_security'],
};

export const DEPOSIT_AMPLITUDE_FLOW: { [key: string]: AmplitudeDepositFlow } = {
  [CustomLanding.PM]: AmplitudeDepositFlow.REVERSE,
  [CustomLanding.PM_V2]: AmplitudeDepositFlow.REVERSE_V2,
  [CustomLanding.AUTH_V2]: AmplitudeDepositFlow.CURRENT_V2,
  [CustomLanding.AUTH]: AmplitudeDepositFlow.CURRENT,
  ['RESELLER_ONLY']: AmplitudeDepositFlow.RESELLER_ONLY,
  [Flavours.REQUIRES_CONFIRM]: AmplitudeDepositFlow.RUC,
  ['DEFAULT']: AmplitudeDepositFlow.CURRENT,
};
